import React, { useState } from "react";
import { Loader2 } from "lucide-react"; // Importing the spinner icon

const FormInputStyle4 = ({
  isValid,
  value,
  onChange,
  label,
  errorMessage,
  tick = false,
  loading = false, // new prop for loading state
  disabled = false,
  labelClassName,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const showFloatingLabel = isFocused || value;

  return (
    <>
      <style>
        {`
          .form-input-wrapper {
            position: relative;
            margin-bottom: 1rem;
            width: 340px;
            margin-left: auto;
            margin-right: auto;
          }

          .form-input-field {
            width: 340px;
            height: 55px;
            border-radius: 5px;
            padding: 20px 40px 8px 12px;
            font-size: 16px;
            outline: none;
          }

          @media (max-width: 340px) {
            .form-input-wrapper {
              width: 300px;
            }
            .form-input-field {
              width: 300px;
            }
          }

          @media (max-width: 320px) {
            .form-input-wrapper {
              width: 310px;
            }
            .form-input-field {
              width: 310px;
            }
          }
        `}
      </style>

      <div className="form-input-wrapper">
        <input
          {...props}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            if (props.onBlur) props.onBlur(e);
          }}
          className="font-atkinson form-input-field"
          disabled={disabled}
          style={{
            border: isValid ? "1px solid #B3B3B3" : "1px solid red",
            backgroundColor: disabled ? "#F5F5F5" : "white",
            color: disabled ? "#A0A0A0" : "inherit",
            cursor: disabled ? "not-allowed" : "text",
          }}
        />

        <label
          htmlFor={label}
          className={labelClassName}
          style={{
            position: "absolute",
            height: showFloatingLabel ? "auto" : "42%",
            width: "60%",
            left: "12px",
            top: showFloatingLabel ? "6px" : "18px",
            fontSize: showFloatingLabel ? "11px" : "14px",
            color: isValid ? "#B3B3B3" : "red",
            backgroundColor: disabled ? "#F5F5F5" : "white",
            transition: "all 0.2s ease-in-out",
            pointerEvents: "none",
          }}
        >
          {label || "Label"}
        </label>

        {/* Show Loader or Tick depending on loading state */}
        {loading && !disabled ? (
          <Loader2
            size={20}
            className="animate-spin"
            style={{
              position: "absolute",
              right: "10px",
              top: "40%",
              color: "#4CAF50",
            }}
          />
        ) : tick && isValid && !disabled ? (
          <img
            src="/assets/img/lightGreenTick.svg"
            alt="tick"
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              height: "20px",
              width: "20px",
            }}
          />
        ) : null}

        {!isValid && !disabled && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
            {errorMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default FormInputStyle4;
